import { z } from 'zod';
import { DateOnlySchema, IdSchema, ListQuerySchema, PageInfoSchema, TimestampSchema, VersionSchema, } from './common.js';
export const ProjectStatusSchema = z.enum([
    'planned',
    'active',
    'on_hold',
    'completed',
    'cancelled',
]);
export const ProjectSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    companyId: IdSchema.nullable(),
    name: z.string(),
    code: z.string().nullable(),
    status: ProjectStatusSchema,
    description: z.string().nullable(),
    startDate: DateOnlySchema.nullable(),
    endDate: DateOnlySchema.nullable(),
    ownerMembershipId: IdSchema.nullable(),
    jobFileId: IdSchema,
    customerAccountId: IdSchema.nullable(),
    sourceLeadId: IdSchema.nullable(),
    /** Organization-defined status; `status` is its stable category. */
    statusDefinitionId: IdSchema.nullable(),
    workCategoryIds: z.array(IdSchema),
    pausedAt: TimestampSchema.nullable(),
    archivedAt: TimestampSchema.nullable(),
    version: VersionSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const ProjectListQuerySchema = ListQuerySchema.extend({
    status: ProjectStatusSchema.optional(),
    statusDefinitionId: IdSchema.optional(),
    companyId: IdSchema.optional(),
    jobFileId: IdSchema.optional(),
    ownerMembershipId: IdSchema.optional(),
    workCategoryId: IdSchema.optional(),
    includeArchived: z.stringbool().default(false),
    includePaused: z.stringbool().default(true),
});
export const ProjectVersionCommandSchema = z.strictObject({ version: VersionSchema });
export const SetProjectWorkCategoriesRequestSchema = z.strictObject({
    workCategoryIds: z.array(IdSchema).max(20),
    version: VersionSchema,
});
export const CreateProjectRequestSchema = z.strictObject({
    companyId: IdSchema.nullable().default(null),
    name: z.string().trim().min(1).max(200),
    code: z.string().trim().max(50).nullable().default(null),
    status: ProjectStatusSchema.default('planned'),
    description: z.string().trim().max(10_000).nullable().default(null),
    startDate: DateOnlySchema.nullable().default(null),
    endDate: DateOnlySchema.nullable().default(null),
    ownerMembershipId: IdSchema.nullable().default(null),
    /** Attach to an existing job file, or omit to open a new one with the given context. */
    jobFileId: IdSchema.nullable().default(null),
    customerAccountId: IdSchema.nullable().default(null),
    propertyId: IdSchema.nullable().default(null),
    /** Preferred over `status`: the category follows the definition. */
    statusDefinitionId: IdSchema.nullable().default(null),
    workCategoryIds: z.array(IdSchema).max(20).default([]),
});
export const UpdateProjectRequestSchema = CreateProjectRequestSchema.omit({
    jobFileId: true,
    propertyId: true,
    workCategoryIds: true,
})
    .partial()
    .extend({
    version: VersionSchema,
});
export const ProjectListSchema = z.strictObject({
    items: z.array(ProjectSchema),
    page: PageInfoSchema,
});
